import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export class IncompleteProfileError extends Error {
  constructor(message) {
    super(message || 'Please complete your profile before booking a meal.');
    this.name = 'IncompleteProfileError';
    this.profileLink = '/profile';
  }
}

// Writes go through Cloud Functions callables (real transactions, idempotent
// transitions, outbox events) instead of direct client Firestore writes.
// Firestore rules now deny direct client writes to meals/bookings/reviews
// entirely (F-09), so this is the only path left.

export const bookMeal = async ({ mealId }) => {
  const callable = httpsCallable(functions, 'bookMeal');
  try {
    const { data } = await callable({ mealId });
    return data;
  } catch (err) {
    if (err.code === 'functions/failed-precondition' && /complete your profile/i.test(err.message || '')) {
      throw new IncompleteProfileError(err.message);
    }
    throw new Error(err.message || 'Failed to book this meal.');
  }
};

export const cancelBooking = async (bookingId) => {
  const callable = httpsCallable(functions, 'cancelBooking');
  try {
    const { data } = await callable({ bookingId });
    return data;
  } catch (err) {
    throw new Error(err.message || 'Failed to cancel this booking.');
  }
};
